export default {
  token: undefined,
  enterprise: undefined,
  hosts: {
    host: 'https://mc.meidd.com',
    mall: 'https://api.meidd.com'
  }
};



// WEBPACK FOOTER //
// ./src/config/qa.js